import React from 'react';

import './modal-acumulation-points.scss';
import GenericModal from '../../../shared/components/modals/generic-modal/generic-modal';
import imgStep1 from "./../../../assets/images/performance/acumulation-step1.webp"
import imgStep1UY from "./../../../assets/images/performance/acumulation-step1-UY.webp"
import imgStep1CL from "./../../../assets/images/performance/PUNTO-1.webp"
import imgStep2 from "./../../../assets/images/performance/acumulation-step2.webp"
import imgStep2CL from "./../../../assets/images/performance/PUNTO-2.webp"
import { getTextAccumulatePoints, getTextAccumulatePointsPartFive, getTextAccumulatePointsPartFour, getTextAccumulatePointsPartThree, getTextAccumulatePointsPartTwo, getTitleAccumulatePoints } from '../../../utils/getPointMessages';

const ModalAcumulationPoints = props => {


  return (
    <GenericModal>
      <span
        onClick={() => props.setModalClose(null)}
        className="icon2-close f-icon f-icon-close-modal"
      />
      <div className="f-modal-acumulation-points-container">
        <div className="f-modal-acumulation-points-container-title">
          <h1>{getTitleAccumulatePoints(process.env.LOCALE)}</h1>
        </div>
        <div className="f-modal-acumulation-points-container-points">
          <div className="f-modal-acumulation-points-container-points-item">
            <div className="f-modal-acumulation-points-container-points-item-img">
              <img src={ imgStep1CL } alt="paso 1 acumula puntos" />
            </div>
            <p>{getTextAccumulatePoints(process.env.LOCALE)}<br/><br/>{getTextAccumulatePointsPartTwo(process.env.LOCALE)}<span>{process.env.LOCALE != "es-CL" ? 'siempre deberás presentar tus empaques.' : '' }</span></p>
          </div>
          <div className="f-modal-acumulation-points-container-points-item">
            <div className="f-modal-acumulation-points-container-points-item-img">
              <img src={ imgStep2CL } alt="paso 2 acumula puntos" />
            </div>
            <p>{getTextAccumulatePointsPartThree(process.env.LOCALE)} 
            <br />
              <br />
            {process.env.LOCALE != "es-CL" ? getTextAccumulatePointsPartFour(process.env.LOCALE) : ''} <span>{process.env.LOCALE != "es-CL" ? getTextAccumulatePointsPartFive(process.env.LOCALE) : ''}</span></p>
          </div>
        </div>
      </div>
    </GenericModal>
  )
}

export default ModalAcumulationPoints;
